import { inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { withAppBaseHref } from 'src/app/@utils/app-base-href';

export function appIconsInitializer() {
  return (): void => _registerIconSet('syn', 'syn-icons.svg');
}

const _registerIconSet = (namespace: string, fileName: string): void => {
  const _iconRegistry = inject(MatIconRegistry);
  const _sanitizer = inject(DomSanitizer);

  _iconRegistry.addSvgIconSetInNamespace(
    namespace,
    _sanitizer.bypassSecurityTrustResourceUrl(
      withAppBaseHref(`/assets/icons/${fileName}`)
    )
  );
};
